var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.dataCollection && _vm.dataCollection.datasets.length ? _c('div', {
    staticClass: "small"
  }, [_c('line-chart', {
    attrs: {
      "chartData": _vm.dataCollection,
      "options": _vm.options
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }